import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CommonUtils from '../utils/siteUtils.js';
import '../styles/Footer.css';


export class Footer extends Component {

    render() {

    return (
        <Container id="footer" fluid>
            <Row>
                <Col className="align-items-center">
                    <div className="siteCopyRight">
                        <span className="legal"><a className="legal" href={CommonUtils.generatePrivacyPolicyUrl()} title="View Privacy Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></span>
                        <span className="legal"><a className="legal" href={CommonUtils.generateTOSUrl()} title="View Terms of Use" target="_blank" rel="noopener noreferrer">Terms of Use</a></span>
                 </div>
                </Col>               
                <Col className="align-items-center">                    
                    <div className="right siteCopyRight">&copy;{new Date().getUTCFullYear()} Optum</div>
                </Col>
            </Row>
     </Container> 
    );
  }
}
